import React from "react";
import TextArea from "antd/es/input/TextArea";
import { useSmartNavigate } from '@/hooks/use-smart-navigate';
import { effectiveUiFormType } from "@/utils/form-type-generic-compat";

const formTypeDisplayLabel = (record) => {
    const eff = effectiveUiFormType(record);
    const map = {
        functional_test: "Functional Test",
        pm_checklist: "PM Checklist",
        generic: "Generic",
    };
    return map[eff] || record.form_type_display || "—";
};

const GotoDetail = ({ id, label, detailPath = "/admin/forms-detail" }) => {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const handleClick = (e) => {
        e.stopPropagation();
        navigateAndCloseTabs(`${detailPath}/${id}`, `${detailPath}/`);
    };
    return label
        ? <a onClick={handleClick}>{label}</a>
        : <a onClick={handleClick}><i className="fas fa-expand-arrows-alt text-lg"></i></a>;
}
export const functionformProps = {
    title: 'functionform',
    name: 'functionform',
    description: ''
}


export const createFunctionalFormColumns = ({
    detailPath = "/admin/forms-detail",
    hideFormType = false,
    hideEquipmentCategory = false,
} = {}) => [
    {
        title: 'key',
        dataIndex: 'id',
        key: 'id',
        editable: false,
        search: false,
        importIngore: true,
        hideInTable: true,
        width: '4%'
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        search: false,
        edit: true,
        sorter: (a, b) => a.name?.localeCompare(b.name),
        formItemProps: {
            rules: [
                {
                    required: true,
                    message: 'required',
                },
            ],
        },
        render: (text, record) => (
            <GotoDetail id={record.id} label={text} detailPath={detailPath} />
        ),
        renderFormItem: () => <TextArea rows={1}/>,
    },
    {
        title: 'Form Type',
        dataIndex: 'form_type',
        key: 'form_type',
        valueType: 'select',
        valueEnum: {
            functional_test: { text: 'Functional Test' },
            pm_checklist: { text: 'PM Checklist' },
            generic: { text: 'Generic' },
        },
        width: '8rem',
        filters: [
            { text: 'Functional Test', value: 'Functional Test' },
            { text: 'PM Checklist', value: 'PM Checklist' },
            { text: 'Generic', value: 'Generic' },
        ],
        onFilter: (value, record) => formTypeDisplayLabel(record) === value,
        sorter: (a, b) =>
            formTypeDisplayLabel(a).localeCompare(formTypeDisplayLabel(b)),
        render: (_, record) => formTypeDisplayLabel(record),
        hideInTable: hideFormType,
    },
    {
        title: 'Equipment Category',
        dataIndex: 'equipment_category_name',
        key: 'equipment_category_name',
        edit: false,
        hideInTable: hideEquipmentCategory || window.innerWidth < 760,
        sorter: (a, b) => a.equipment_category_name?.localeCompare(b.equipment_category_name),
    },
    {
        title: 'Company',
        dataIndex: 'company_name',
        key: 'company_name',
        edit: false,
        hideInTable: window.innerWidth < 760,
        sorter: (a, b) => (a.company_name || '').localeCompare(b.company_name || ''),
        render: (text, record) => {
            const isSystem = !record.company_name;
            return (
                <span style={{ color: isSystem ? 'var(--color-primary, #4482FF)' : undefined, fontWeight: isSystem ? 500 : undefined }}>
                    {text || 'System'}
                </span>
            );
        },
    },
];

export const FunctionalFormColumns = createFunctionalFormColumns();
